<template>
  <customdialog
    v-model="dialog"
    :maxWidth="options.width"
    :title="title"
    :cardtextstyle="'height: 350px;'"
  >
    <v-form
      ref="formaktarim"
      id="formaktarim"
      method="post"
      enctype="multipart/form-data"
      lazy-validation
    >
      <input
        type="file"
        id="files"
        ref="files"
        @change="onFileChange"
        :accept="FileCode"
        multiple
      />
    </v-form>

    <br />

    <template slot="btn">
      <v-btn color="primary" flat @click.native="yes()">{{
        btnYesCaption
      }}</v-btn>
    </template>
  </customdialog>
</template>

<script>
import customdialog from "@/components/app/coper/comp/customdialog.vue";
import tool from "@/components/app/coper/tools";

export default {
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,

      title: null,
      FileCode: "text/xml",
      btnYesCaption: this.$t("OK"),

      url: null,

      options: {
        color: "primary",
        width: 450,
      },
      files: [],
      fileBase64: "",
    };
  },
  components: {
    customdialog,
  },
  methods: {
    open(title, FileCode) {
      this.btnYesCaption = "Kaydet";
      this.title = title;
      
      
      if(FileCode!="")
      {
        this.FileCode = FileCode;
      }
      
      this.fileBase64 = null;

      this.$refs.files.value=null;

      this.dialog = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    onFileChange(e) {
      this.files = e.target.files;
    },

    yes() {
      if (this.files.length > 0) {
        this.resolve(this.files);
        this.dialog = false;
      }
    },
    cancel() {
      this.resolve(null);
      this.dialog = false;
    },
  },
};
</script>



